import { render, staticRenderFns } from "./card-header.vue?vue&type=template&id=1888cc24&scoped=true"
import script from "./card-header.vue?vue&type=script&lang=js"
export * from "./card-header.vue?vue&type=script&lang=js"
import style0 from "./card-header.vue?vue&type=style&index=0&id=1888cc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888cc24",
  null
  
)

export default component.exports